import { TextInput, FieldSet, Label, RadioButton } from '@nokia-csf-uxr/ccfk';
import { FieldSetContent, Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import { RadioButtonLabelContent } from '@nokia-csf-uxr/ccfk/RadioButton';
import React from 'react';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import ValueInput from '../../ValueInput';
import Form from 'react-bootstrap/esm/Form';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Path details component (length & sites)
 */
export default class PathDetails extends WLDInputComponent {

    constructor(props: {band: number}) {
        super(props);
    }

    /**
     * Function is called when the path lenght is changed
     * @param link  user's data
     * @param newData New data which has been selected
     */
    onChange(link: Readonly<any>, newData: {index:number, idDistUnit: number}) {
        link.define("distanceUnits", newData)
        if(newData.idDistUnit == 1) { // Miles to kilometers
            link.define("site_length", (link.site_length*1.609).toFixed(2))
        } else { // Kilometers to miles
            link.define("site_length", (link.site_length/1.609).toFixed(2))
        }
    }

    render() {
        return (
            <Form.Group>
                { this.props.band == 1 ?
                <SingleBandLinkUserContext.Consumer>
                {(link) => (
                    <>
                        <Container>
                            <Row>
                                <Col xs={6}>
                                    <Form.Label>Link's length</Form.Label>
                                    <ValueInput valueType="float" value={link.site_length != null ? link.site_length : 1}
                                        onChange={(data: any) => {
                                            let dataNumber = parseFloat(data);
                                            if(!Number.isNaN(dataNumber)) {
                                                link.define("site_length", dataNumber)
                                            } else {
                                                link.define("site_length", data)
                                            }
                                        }}  
                                        onBlur={(data: any, error: any, errorMsg: any) => {
                                            data = parseFloat(data).toFixed(2);
                                            if(Number.isNaN(data) || data <= 0) {
                                                error(true);
                                                errorMsg("This value must be higher than 0.0");
                                            }
                                        }}></ValueInput>

                                    
                                </Col>
                        
                                <Col xs={6}>
                                    <FieldSet>
                                        <Form.Label>Distance unit</Form.Label>
                                        <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                            <SingleBandLinkReferenceContext.Consumer>
                                            {(linkRef) => (
                                                <>
                                                { linkRef?.distanceUnits?.map((distUnit: {idDistUnit: number, name: string, shortname: string}, index: any) =>
                                                    <Form.Check
                                                        type="radio"
                                                        label={ distUnit.name }
                                                        className={linkRef?.distanceUnits.length == (index+1) ? "ms-sm-3" : ""}
                                                        checked={link?.distanceUnits?.idDistUnit === distUnit.idDistUnit}
                                                        onChange={(e) => this.onChange(link, {index: index, ...distUnit}) }
                                                    />
                                                ) }
                                                </>
                                            )}
                                            </SingleBandLinkReferenceContext.Consumer>  
                                        </FieldSetContent>

                                    </FieldSet>
                                </Col>
                            </Row>
                            
                            <Row>
                                <Col>
                                    <Form.Label>Site 1</Form.Label>
                                    <TextInput onChange={(e) => link.define("site1", e.target.value)} value={link.site1 != null ? link.site1 : ""}></TextInput>
                                </Col>
                                <Col>
                                    <Form.Label>Site 2</Form.Label>
                                    <TextInput onChange={(e) => link.define("site2", e.target.value)} value={link.site2 != null ? link.site2 : ""}></TextInput>
                                </Col>
                            </Row>

                            <Row>
                                <Form.Label>Margin (dB)</Form.Label>
                                <ValueInput valueType="float" value={link.margin != null ? link.margin : 0}
                                    onChange={(data: any) => {
                                        data = parseFloat(data);
                                        if(!Number.isNaN(data)) {
                                            link.define("margin", parseFloat(data))
                                        } else {
                                            link.define("margin", 0)
                                        }
                                    }}  
                                    onBlur={(data: any, error: any) => {
                                        data = parseFloat(data);
                                        if(data < 0) {
                                            error(true);
                                        }
                                    }}></ValueInput>
                            </Row>
                        </Container>
                    </>
                )}
                </SingleBandLinkUserContext.Consumer>
            :
            <>
                <DualBandLinkUserContext.Consumer>
                    {(link) => (
                        <>
                            <Container>
                                <Row>
                                    <Col xs={6}>
                                        <Form.Label>Link's length</Form.Label>
                                        <ValueInput valueType="float" value={link.site_length != null ? link.site_length : 1}
                                            onChange={(data: any) => {
                                                let dataNumber = parseFloat(data);
                                                if(!Number.isNaN(dataNumber)) {
                                                    link.define("site_length", dataNumber)
                                                } else {
                                                    link.define("site_length", data)
                                                }
                                            }}  
                                            onBlur={(data: any, error: any, errorMsg: any) => {
                                                data = parseFloat(data).toFixed(2);
                                                if(Number.isNaN(data) || data <= 0) {
                                                    error(true);
                                                    errorMsg("This value must be higher than 0.0");
                                                }
                                            }}></ValueInput>

                                        
                                    </Col>
                            
                                    <Col xs={6}>
                                        <FieldSet>
                                            <Form.Label>Distance unit</Form.Label>
                                            <FieldSetContent role="radiogroup" className="justify-content-sm-center standard-FieldSetContent center-radiobnt">
                                                <DualBandLinkReferenceContext.Consumer>
                                                {(linkRef) => (
                                                    <>
                                                    { linkRef?.distanceUnits?.map((distUnit: {idDistUnit: number, name: string, shortname: string}, index: any) =>
                                                        <Form.Check
                                                            type="radio"
                                                            label={ distUnit.name }
                                                            className={linkRef?.distanceUnits?.length == (index+1) ? "ms-sm-3" : ""}
                                                            checked={link?.distanceUnits?.idDistUnit === distUnit.idDistUnit}
                                                            onChange={(e) => this.onChange(link, {index: index, ...distUnit}) }
                                                        />
                                                    ) }
                                                    </>
                                                )}
                                                </DualBandLinkReferenceContext.Consumer>  
                                            </FieldSetContent>

                                        </FieldSet>
                                    </Col>
                                </Row>
                                
                                <Row>
                                    <Col>
                                        <Form.Label>Site 1</Form.Label>
                                        <TextInput onChange={(e) => link.define("site1", e.target.value)} value={link.site1 != null ? link.site1 : ""}></TextInput>
                                    </Col>
                                    <Col>
                                        <Form.Label>Site 2</Form.Label>
                                        <TextInput onChange={(e) => link.define("site2", e.target.value)} value={link.site2 != null ? link.site2 : ""}></TextInput>
                                    </Col>
                                </Row>

                                <Row>
                                    <Form.Label>Margin (dB)</Form.Label>
                                    <ValueInput valueType="float" value={link.margin != null ? link.margin : 0}
                                        onChange={(data: any) => {
                                            data = parseFloat(data);
                                            if(!Number.isNaN(data)) {
                                                link.define("margin", parseFloat(data))
                                            } else {
                                                link.define("margin", 0)
                                            }
                                        }}  
                                        onBlur={(data: any, error: any) => {
                                            data = parseFloat(data);
                                            if(data < 0) {
                                                error(true);
                                            }
                                        }}></ValueInput>
                                </Row>
                            </Container>
                        </>
                    )}
                </DualBandLinkUserContext.Consumer>
            </>
            }
            </Form.Group>
        );
    }

}
